
import React from 'react';
import { t } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { commonControlsConfig } from '../utils';

const { showLabels } = DEFAULT_FORM_DATA;

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
    {
      ...sections.legacyRegularTime,
      expanded: false
    },
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        ['metric'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
            name: 'row_limit',
            config: {
              ...sharedControls.row_limit,
              choices: [...Array(10).keys()].map(n => n + 1),
              default: DEFAULT_FORM_DATA.rowLimit,
            },
          },
        ],
       ],
     },
     {
       label: t('Chart Options'),
       tabOverride: 'customize',
       expanded: false,
       controlSetRows: [
        //  ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
         [
           {
             name: 'show_labels',
             config: {
               type: 'CheckboxControl',
               label: t('Show Labels'),
               renderTrigger: true,
               default: showLabels,
               description: t('Whether to display the labels.'),
             },
           },
         ],

         [
          {
            name: 'rangeMin',
            config: {
              ...commonControlsConfig.number,
              label: t('Gauge Min value'),
              description: t(
                'Minimum value for Gauge.',
              ),
              default: DEFAULT_FORM_DATA.rangeMin,
              renderTrigger: true,
            },
          }
        ],
        [
          {
            name: 'rangeMax',
            config: {
              ...commonControlsConfig.number,
              label: t('Gauge Max value'),
              description: t(
                'Maximum value for Gauge.',
              ),
              default: DEFAULT_FORM_DATA.rangeMax,
              renderTrigger: true,
            },
          }
        ],

        [
          {
            name: 'gradeLabel1',
            config: {
              ...commonControlsConfig.text,
              label: t('Grade 1 Label'),
              description: t(
                'Label for Grade 1.',
              ),
              default: DEFAULT_FORM_DATA.gradeLabel1,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'gradeColor1',
            config: {
              ...sharedControls.color_picker,
              label: t('Grade 1 Color'),
              default: DEFAULT_FORM_DATA.gradeColor1,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'threshold4',
            config: {
              ...commonControlsConfig.percentage,
              label: t('First Threshold (%)'),
              description: t(
                'Threshold for Grade 2 as a percentage.',
              ),
              default: DEFAULT_FORM_DATA.threshold2,
              renderTrigger: true,
            },
          }
        ],

         [
          {
            name: 'gradeLabel2',
            config: {
              ...commonControlsConfig.text,
              label: t('Grade 2 Label'),
              description: t(
                'Label for Grade 2.',
              ),
              default: DEFAULT_FORM_DATA.gradeLabel2,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'gradeColor2',
            config: {
              ...sharedControls.color_picker,
              label: t('Grade 2 Color'),
              default: DEFAULT_FORM_DATA.gradeColor2,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'threshold3',
            config: {
              ...commonControlsConfig.percentage,
              label: t('Second Threshold (%)'),
              description: t(
                'Threshold for Grade 3 as a percentage.',
              ),
              default: DEFAULT_FORM_DATA.threshold3,
              renderTrigger: true,
            },
          }
        ],
         [
          {
            name: 'gradeLabel3',
            config: {
              ...commonControlsConfig.text,
              label: t('Grade 3 Label'),
              description: t(
                'Label for Grade 3.',
              ),
              default: DEFAULT_FORM_DATA.gradeLabel3,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'gradeColor3',
            config: {
              ...sharedControls.color_picker,
              label: t('Grade 3 Color'),
              default: DEFAULT_FORM_DATA.gradeColor3,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'threshold2',
            config: {
              ...commonControlsConfig.percentage,
              label: t('Third Threshold (%)'),
              description: t(
                'Threshold for Grade 4 as a percentage.',
              ),
              default: DEFAULT_FORM_DATA.threshold4,
              renderTrigger: true,
            },
          }
        ],
         [
          {
            name: 'gradeLabel4',
            config: {
              ...commonControlsConfig.text,
              label: t('Grade 4 Label'),
              description: t(
                'Label for Grade 4.',
              ),
              default: DEFAULT_FORM_DATA.gradeLabel4,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'gradeColor4',
            config: {
              ...sharedControls.color_picker,
              label: t('Grade 4 Color'),
              default: DEFAULT_FORM_DATA.gradeColor4,
              renderTrigger: true,
            },
          }
         ],
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => ({
     ...formData,
     metric: formData.standardizedFormData.standardizedState.metrics[0],
     groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 